import { render } from "./EdmCampaignList.vue?vue&type=template&id=4fdbff11"
import script from "./EdmCampaignList.vue?vue&type=script&lang=js"
export * from "./EdmCampaignList.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__